import { createContext } from 'react';

const AmplitudeContext = createContext(undefined);

export default AmplitudeContext;
